import { Directive, Input, OnDestroy, OnInit, Optional, Renderer2, Self, SkipSelf } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { delay, takeUntil, tap } from 'rxjs/operators';

import { MediaQuery } from '../../services/media-query.service';
import { DropdownBase } from './dropdown.base';

@Directive({
  selector: '[dpwChild]',
})
export class OverlayChildDirective implements OnInit, OnDestroy {
  private $destroy = new Subject<void>();

  @Input()
  dpwChildEnabled = true;

  constructor(
    private renderer: Renderer2,
    private media: MediaQuery,
    @Optional() @Self() private dropdown?: DropdownBase,
    @Optional() @SkipSelf() public parent?: DropdownBase,
    @Optional() @SkipSelf() public overlayChild?: OverlayChildDirective,
  ) {}

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }

  ngOnInit(): void {
    if (!this.parent) {
      return;
    }
    const dropdown = this.dropdown;
    const parent = this.parent;
    // TODO: observe media changes
    if (parent && dropdown && this.media.current !== 'small') {
      if (this.overlayChild && this.overlayChild.parent) {
        dropdown.overlayOrigin = this.overlayChild.parent.overlayOrigin;
      } else {
        dropdown.overlayOrigin = parent.overlayOrigin;
      }
    }
    if (dropdown && parent && this.dpwChildEnabled) {
      this.observeDropdownEvents(dropdown, parent);
    }
  }

  observeDropdownEvents(dropdown: DropdownBase, parent: DropdownBase) {
    dropdown.beforeOpen
      .pipe(
        tap(() => {
          this.renderer.setStyle(
            parent.cdkOverlay.overlayRef.hostElement,
            'transition',
            'transform .3s ease, opacity .4s',
          );
        }),
        delay(0),
        takeUntil(this.$destroy),
      )
      .subscribe(() => {
        parent.isEnabled = false;
        if (this.media.current !== 'small') {
          this.renderer.setStyle(parent.cdkOverlay.overlayRef.hostElement, 'opacity', `0`);
          this.renderer.setStyle(parent.cdkOverlay.overlayRef.hostElement, 'transform', `translateY(50px)`);
        } else {
          const offsetToHide = parent.cdkOverlay.overlayRef.overlayElement.firstElementChild?.clientHeight || 150;
          this.renderer.setStyle(
            parent.cdkOverlay.overlayRef.hostElement,
            'transform',
            `translateY(${offsetToHide - 100}px)`,
          );
        }
      });
    if (dropdown.cdkOverlay.overlayRef) {
      dropdown.beforeOpen.pipe(delay(0), takeUntil(this.$destroy)).subscribe(() => {
        fromEvent(dropdown.cdkOverlay.overlayRef.overlayElement, 'click')
          .pipe(takeUntil(this.$destroy))
          .subscribe(e => {
            e.stopImmediatePropagation();
          });
      });
    }
    dropdown.closed.pipe(takeUntil(this.$destroy)).subscribe(() => {
      this.renderer.setStyle(parent.cdkOverlay.overlayRef.hostElement, 'transform', '');
      this.renderer.setStyle(parent.cdkOverlay.overlayRef.hostElement, 'opacity', '');
      parent.isEnabled = true;
    });
  }
}
